// extracted by mini-css-extract-plugin
module.exports = {"TimerManager__wrapper":"TimerManager_TimerManager__wrapper__2Wt1a","TimerManager__wrapper__table":"TimerManager_TimerManager__wrapper__table__28-jD"};